import React, { useEffect, useRef, useState } from "react";
import { TOAST_EVENT } from "../utils/toast";

const ICONS = { ok: "✓", warn: "!", error: "✕" };
const TITLES = { ok: "Success", warn: "Please check", error: "Something went wrong" };
const DURATION = 4500;
const MAX_SHOWN = 3;

// Shows the messages sent with toast() from utils/toast.js
export default function Toaster() {
  const [items, setItems] = useState([]);
  const nextId = useRef(1);

  useEffect(() => {
    const timers = new Set();
    const onToast = (event) => {
      const id = nextId.current++;
      const { text, tone } = event.detail;
      setItems((list) => [...list.slice(-(MAX_SHOWN - 1)), { id, text, tone: ICONS[tone] ? tone : "ok" }]);
      const timer = setTimeout(() => {
        setItems((list) => list.filter((item) => item.id !== id));
        timers.delete(timer);
      }, DURATION);
      timers.add(timer);
    };
    window.addEventListener(TOAST_EVENT, onToast);
    return () => {
      window.removeEventListener(TOAST_EVENT, onToast);
      timers.forEach(clearTimeout);
    };
  }, []);

  const close = (id) => setItems((list) => list.filter((item) => item.id !== id));

  return (
    <div className="toaster" aria-live="polite">
      {items.map((item) => (
        <div key={item.id} className={`oz-toast oz-toast-${item.tone}`} role={item.tone === "error" ? "alert" : "status"}>
          <span className="toast-icon" aria-hidden="true">{ICONS[item.tone]}</span>
          <div className="toast-copy"><b>{TITLES[item.tone]}</b><span>{item.text}</span></div>
          <button className="toast-close" onClick={() => close(item.id)} aria-label="Dismiss">×</button>
        </div>
      ))}
    </div>
  );
}
